import type { IconData } from '@stacksjs/iconify-core'

export const mallSolid: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M32 14.472a40 40 0 0 1-3.07-.193c-1.84-.196-3.16-1.642-3.312-3.418A34 34 0 0 1 25.5 8c0-1.132.053-2.099.118-2.86c.153-1.777 1.472-3.223 3.312-3.42c1.106-.117 2.738-.22 5.07-.22s3.964.103 5.07.22c1.84.197 3.16 1.643 3.312 3.42c.065.761.118 1.728.118 2.86s-.053 2.099-.118 2.86c-.153 1.777-1.472 3.223-3.312 3.42a41 41 0 0 1-3.07.192v4.282c1.172.25 2.297.512 3.36.788c3.176.823 5.14 3.746 5.14 6.875V30.5h-41v-8.503c0-3.575 2.909-6.537 6.562-6.372c6.52.295 14.743 1.104 21.938 2.36zM33 33.5h11.5v10h.5a1.5 1.5 0 0 1 0 3H3a1.5 1.5 0 0 1 0-3h.5v-10H15v10h3v-10h12v10h3z\"/>",
  "width": 48,
  "height": 48,
  "viewBox": "0 0 48 48"
}

export default mallSolid
